import { ArrowLeftOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, InputNumber, notification, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import PqrTable from "./PqrTable";
import xmlDisable from "../../assets/xml-disable.png";
import xml from "../../assets/xml.png";
import { hasEditPermission } from "../../helpers/rabc-helper";
import {
  GENERATE_PQR_REQUEST,
  GET_REPORTS_INFO_REQUEST,
} from "../../redux/data360Live_PQR/types";

const PqrReportTableLive = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isGenerating } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const boundary = queryParams.get("boundary");
  const pqrReport = useSelector(
    (state) => state?.data360LivePqrReducer?.reportsInfo?.pqrReport
  );

  const savedBoundary = pqrReport ? Number(pqrReport.boundary || 10) : [];
  const BoundaryValue = boundary ? boundary : savedBoundary;
  const [inputBoundary, setInputBoundary] = useState(BoundaryValue);
  const [isGenerateClicked, setIsGenerateClicked] = useState(false);
  const { weld_numbers } = useParams();
  const [editedDataFromTable, setEditedDataFromTable] = useState([]);
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );

  const pqrData = useSelector((state) => state?.data360LivePqrReducer);
  const GeneratedData = useSelector(
    (state) => state?.data360LivePqrReducer?.pqrReportData
  );
  const loading = pqrData?.loading;
  const [hasChanged, setHasChanged] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [isToleranceChanged, setIsToleranceChanged] = useState(false);
  const [excludedTlogsParsed, setExcludedTlogsParsed] = useState([]);

  const hasMinimumColumns = () => {
    const selectedColumns =
      visitbleColumnsAggrid?.filter((col) => col !== "Pass Name") || [];
    return selectedColumns.length >= 1;
  };

  const reducerList = useSelector((state) => state);

  const canEdit = hasEditPermission(reducerList?.auth?.userDetails);

  const fetchPqrData = (boundaryValue) => {
    dispatch({
      type: GET_REPORTS_INFO_REQUEST,
      payload: {
        project_id: currentProject.project_id,
        weld_numbers,
        boundary: boundaryValue,
        cb: (data) => {
          // Set visible columns from saved preferences if available
          if (data?.pqrReport?.selected_columns?.selected_columns?.length > 0) {
            setVisibleColumnsAggrid(
              data.pqrReport.selected_columns.selected_columns
            );
          }

          const excludedTlogs =
            data?.pqrReport?.excluded_tlogs_key?.excluded_tlogs;
          const hasValidExcludedTlogs =
            excludedTlogs &&
            excludedTlogs.length > 0 &&
            Object.keys(excludedTlogs[0] || {}).length > 0;
          setExcludedTlogsParsed(excludedTlogs);
          const fallbackPayload = {
            projectId: currentProject.project_id,
            weldNumbers: String(weld_numbers).split(',').map(n => n.trim()).filter(Boolean),
            email_address: "vijayajay3535@gmail.com",
            boundary: boundaryValue,
            ...(hasValidExcludedTlogs && { excluded_tlogs: excludedTlogs }),
            columns_add:
              data?.pqrReport?.selected_columns?.selected_columns ||
              visitbleColumnsAggrid?.filter((col) => col !== "Pass Name") ||
              [],
          };

          if (
            !data?.pqrReport?.max_min_data?.max_min_data ||
            !data?.pqrReport?.excluded_tlogs_key?.excluded_tlogs
          ) {
            dispatch({
              type: GENERATE_PQR_REQUEST,
              payload: fallbackPayload,
            });

            return;
          }

          try {
            const { pqrReport } = data;
            const parsedExcludedTlogs =
              pqrReport?.excluded_tlogs_key?.excluded_tlogs;
            setExcludedTlogsParsed(parsedExcludedTlogs);
            const payload = {
              projectId: pqrReport.project_id,
              weldNumbers:
                typeof pqrReport.weld_numbers === "string"
                  ? pqrReport.weld_numbers.split(",").map((num) => num.trim())
                  : [],
              email_address: "vijayajay3535@gmail.com",
              boundary: Number(pqrReport.boundary) || 10,
              columns_add: Array.isArray(
                pqrReport.selected_columns?.selected_columns
              )
                ? pqrReport.selected_columns.selected_columns
                : visitbleColumnsAggrid?.filter((col) => col !== "Pass Name") ||
                  [],
              items: pqrReport.max_min_data.max_min_data.map((item) => ({
                passName: item.passName || "Root",
                preHeatInterPassTemperatureMin:
                  item.preHeatInterPassTemperatureMin || "",
                preHeatInterPassTemperatureMax:
                  item.preHeatInterPassTemperatureMax || "",
                arcEnergyMin: item.arcEnergyMin || "",
                arcEnergyMax: item.arcEnergyMax || "",
                averagePulseFrequencyMin: item.averagePulseFrequencyMin || "",
                averagePulseFrequencyMax: item.averagePulseFrequencyMax || "",
                averagePulseTimeMin: item.averagePulseTimeMin || "",
                averagePulseTimeMax: item.averagePulseTimeMax || "",
                averagePeakCurrentMin: item.averagePeakCurrentMin || "",
                averagePeakCurrentMax: item.averagePeakCurrentMax || "",
                averageBaseCurrentMin: item.averageBaseCurrentMin || "",
                averageBaseCurrentMax: item.averageBaseCurrentMax || "",
              })),
              excluded_tlogs: parsedExcludedTlogs,
            };

            dispatch({
              type: GENERATE_PQR_REQUEST,
              payload,
            });
          } catch (error) {
            console.error("Error processing report data:", error);
          }
        },
      },
    });
  };

  useEffect(() => {
    if (currentProject?.project_id && weld_numbers) {
      fetchPqrData(BoundaryValue);
    }
  }, []);

  const weldNumberArray = weld_numbers ? weld_numbers.split(",").join(",") : "";
  const matchingReport = GeneratedData?.pqrReports?.find((report) => {
    const reportWeldNumbers = report.weld_numbers;
    return reportWeldNumbers === weldNumberArray;
  });

  const maxMinData = (pqrReport?.max_min_data?.max_min_data || []).map(
    (item) => ({
      passName: item.passName,
      preHeatInterPassTemperatureMin: parseFloat(
        item.preHeatInterPassTemperatureMin
      ),
      preHeatInterPassTemperatureMax: parseFloat(
        item.preHeatInterPassTemperatureMax
      ),
      arcEnergyMin: parseFloat(item.arcEnergyMin),
      arcEnergyMax: parseFloat(item.arcEnergyMax),
      averagePulseFrequencyMin: parseFloat(item.averagePulseFrequencyMin),
      averagePulseFrequencyMax: parseFloat(item.averagePulseFrequencyMax),
      averagePulseTimeMin: parseFloat(item.averagePulseTimeMin),
      averagePulseTimeMax: parseFloat(item.averagePulseTimeMax),
      averagePeakCurrentMin: parseFloat(item.averagePeakCurrentMin),
      averagePeakCurrentMax: parseFloat(item.averagePeakCurrentMax),
      averageBaseCurrentMin: parseFloat(item.averageBaseCurrentMin),
      averageBaseCurrentMax: parseFloat(item.averageBaseCurrentMax),
    })
  );
  const handleBoundaryChange = (value) => {
    setInputBoundary(value);
    setIsToleranceChanged(true);
  };

  const validateMinMax = (item) => {
    const validations = [
      { min: "preHeatMin", max: "preHeatMax" },
      { min: "arcEnergyMin", max: "arcEnergyMax" },
      { min: "pulseFreqMin", max: "pulseFreqMax" },
      { min: "pulseTimeMin", max: "pulseTimeMax" },
      { min: "peakCurrentMin", max: "peakCurrentMax" },
      { min: "baseCurrentMin", max: "baseCurrentMax" },
    ];

    for (const { min, max } of validations) {
      if (
        item[min] !== undefined &&
        item[max] !== undefined &&
        Number(item[min]) > Number(item[max])
      ) {
        return false;
      }
    }

    return true;
  };

  const columnsAvailable = [
    "Pass Name",
    "Pre-Heat/ Interpass Temperature",
    "Average Voltage",
    "Average Current",
    "Average Wire Feed Speed",
    "Average Oscillation Width",
    "Average Oscillation Frequency",
    "Average Travel Speed",
    "Arc Energy",
    "Average Pulse Frequency",
    "Average Pulse Time",
    "Average Peak Current",
    "Average Base Current",
  ];

  const [visitbleColumnsAggrid, setVisibleColumnsAggrid] =
    useState(columnsAvailable);

  const mapValuesToPayload = (item) => {
    let mappedValues = {
      ...(item.passName && { passName: item.passName }),
      ...(item.preHeatMin && {
        preHeatInterPassTemperatureMin: item.preHeatMin.toString(),
      }),
      ...(item.preHeatMax && {
        preHeatInterPassTemperatureMax: item.preHeatMax.toString(),
      }),
      ...(item.arcEnergyMin && { arcEnergyMin: item.arcEnergyMin.toString() }),
      ...(item.arcEnergyMax && { arcEnergyMax: item.arcEnergyMax.toString() }),
      ...(item.pulseFreqMin && {
        averagePulseFrequencyMin: item.pulseFreqMin.toString(),
      }),
      ...(item.pulseFreqMax && {
        averagePulseFrequencyMax: item.pulseFreqMax.toString(),
      }),
      ...(item.pulseTimeMin && {
        averagePulseTimeMin: item.pulseTimeMin.toString(),
      }),
      ...(item.pulseTimeMax && {
        averagePulseTimeMax: item.pulseTimeMax.toString(),
      }),
      ...(item.peakCurrentMin && {
        averagePeakCurrentMin: item.peakCurrentMin.toString(),
      }),
      ...(item.peakCurrentMax && {
        averagePeakCurrentMax: item.peakCurrentMax.toString(),
      }),
      ...(item.baseCurrentMin && {
        averageBaseCurrentMin: item.baseCurrentMin.toString(),
      }),
      ...(item.baseCurrentMax && {
        averageBaseCurrentMax: item.baseCurrentMax.toString(),
      }),
    };

    return mappedValues;
  };

  const handleReGenerateClick = () => {
    if (inputBoundary === null) {
      notification.warning({
        message: "Please enter a valid boundary value to re-generate the data.",
      });
      return;
    }
    setIsGenerateClicked(true);

    let isInvalid = editedDataFromTable
      ?.map((ite) => {
        let { key, ...rest } = ite;
        console.log(key, "key");
        return validateMinMax(rest);
      })
      .filter((ite) => ite === false);

    if (isInvalid.length === 0) {
      const sortedData = visitbleColumnsAggrid
        ?.filter((ite) => ite != "Pass Name")
        .sort((a, b) => {
          return columnsAvailable.indexOf(a) - columnsAvailable.indexOf(b);
        });

      let payload = {
        projectId: currentProject.project_id,
        weldNumbers: [weld_numbers].flat().map((item) => String(item).trim()),
        email_address: "vijayajay3535@gmail.com",
        boundary: inputBoundary,
        columns_add: sortedData,
        items: editedDataFromTable?.map((ite) => {
          let { key, ...rest } = ite;
          console.log(key);
          return {
            ...mapValuesToPayload(rest),
          };
        }),
        excluded_tlogs: excludedTlogsParsed,
      };

      const commonPayload = {
        project_id: currentProject.project_id,
        weld_numbers,
        boundary: inputBoundary,
        shouldExecuteStopLoader: false,
      };

      dispatch({
        type: GENERATE_PQR_REQUEST,
        payload,
        cb: () => {
          history.push(
            `/data360-live-pqr-table-data/${weld_numbers}?boundary=${inputBoundary}`
          );
          dispatch({
            type: GET_REPORTS_INFO_REQUEST,
            payload: commonPayload,
            cb: (pqrData) => {
              const { selected_columns } = pqrData?.recordList?.[0] || {};
              const selectedColumns = JSON.parse(
                selected_columns || "{}"
              )?.selected_columns;

              if (selectedColumns?.length > 0) {
                setVisibleColumnsAggrid(selectedColumns);
              }
            },
          });
        },
      });
    } else {
      notification.warning({
        message: "Check your input values",
        description:
          "Some input values are invalid. Please ensure Min values are less than Max values.",
        duration: 5,
        placement: "topRight",
      });
    }
  };
  const weldNumbersMatch = pqrReport?.weld_numbers == weldNumberArray;

  const handleDownload = () => {
    if (matchingReport?.pqr_report_url) {
      window.open(pqrReport?.pqr_report_url, "_blank");
    } else if (weldNumbersMatch && pqrReport?.pqr_report_url !== null) {
      window.open(pqrReport?.pqr_report_url, "_blank");
    } else {
      console.log("No matching report or URL not found");
    }
  };

  const fetchPQRReportLinkData = () => {
    const payload = {
      project_id: currentProject?.project_id,
      weld_numbers,
      boundary: inputBoundary,
    };

    dispatch({
      type: GET_REPORTS_INFO_REQUEST,
      payload,
    });
    setIsGenerateClicked(false);
  };

  return (
    <>
      <div className="slogweld-title">
        <Link to="/data360Live/pqr-report">
          <div className="back_equip">
            <Tooltip title={"Back"}>
              <ArrowLeftOutlined />
            </Tooltip>
            <h2 className="slogweld-header-active">PQR Report</h2>
          </div>
        </Link>

        <div className="back_equip-unActive">
          <ArrowLeftOutlined />
          <h2 className="slogweld-header-weldnuber">
            {t("slogColumntitle.weld")} {weldNumberArray}
          </h2>
        </div>
        {!loading && (
          <>
            <div className="boundary-input">
              <label className="tolerance-lable">Tolerance</label>
              <InputNumber
                defaultValue={inputBoundary}
                formatter={(value) => `${value}%`}
                onChange={handleBoundaryChange}
                className="re-generate-input"
              />
              {canEdit && (
                <Button
                  type="primary"
                  className="re-generate-btn"
                  onClick={(data) => {
                    handleReGenerateClick(data);
                  }}
                  disabled={
                    (!hasChanged && !isEdited && !isToleranceChanged) ||
                    !hasMinimumColumns()
                  }
                >
                  Generate
                </Button>
              )}
              <Tooltip
                placement="topLeft"
                title={
                  isGenerateClicked
                    ? "Please wait until the report generates."
                    : null
                }
              >
                {isGenerateClicked ||
                !(
                  (matchingReport?.pqr_report_url &&
                    matchingReport?.pqr_report_url == "") ||
                  (weldNumbersMatch &&
                    pqrReport?.pqr_report_url !== null &&
                    pqrReport?.pqr_report_url !== "")
                ) ? (
                  <img
                    src={xmlDisable}
                    alt="Download PQR Report"
                    className="re-generate-btn-save-pd-disable"
                  />
                ) : (
                  <img
                    src={xml}
                    alt="Download PQR Report"
                    onClick={handleDownload}
                    className="re-generate-btn-save-pd"
                  />
                )}
              </Tooltip>

              {((isGenerating && !pqrReport?.pqr_report_url) ||
                isGenerateClicked ||
                !(
                  matchingReport?.pqr_report_url ||
                  (weldNumbersMatch && pqrReport?.pqr_report_url !== null)
                )) && (
                <Tooltip placement="topLeft" title="Reload">
                  <Button
                    className="refresh-download"
                    onClick={() => fetchPQRReportLinkData()}
                  >
                    <ReloadOutlined />
                  </Button>
                </Tooltip>
              )}
            </div>
          </>
        )}
      </div>

      <PqrTable
        weld_number={weldNumberArray}
        loadPqrData={loading}
        pqrData={pqrData}
        maxMinData={maxMinData}
        setIsEdited={setIsEdited}
        boundary={boundary}
        editedDataFromTable={editedDataFromTable}
        setEditedDataFromTable={setEditedDataFromTable}
        visitbleColumnsAggrid={visitbleColumnsAggrid}
        setVisibleColumnsAggrid={(data) => {
          setHasChanged(true);
          setVisibleColumnsAggrid(data);
        }}
      />
    </>
  );
};

export default PqrReportTableLive;
